//
//  progress-bar.ts
//  moods-film-ui-master
//
//  Created by romainharvier@gmail.com on 10/08/2019.
//  Copyright © 2019 Moods. All rights reserved.
//

import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class ProgressBar extends Vue {

    @Prop(String) private readonly type!: string;

    private width: number = 0;

    private mounted(): void {

        window.addEventListener('scroll', this.handleScroll);

        window.dispatchEvent(new Event('scroll'));

    }

    private destroyed(): void {

        window.removeEventListener('scroll', this.handleScroll);

    }

    private handleScroll() {

        const height: number = document.documentElement.scrollHeight - document.documentElement.clientHeight;

        this.width = (window.scrollY / height) * 100;

        const eventWidth: number = Math.ceil(this.width);

        if (eventWidth === 0) {

            this.$emit('begin');

        }

        if (eventWidth === 100) {

            this.$emit('complete');

        }

    }

}
